import {Component} from '@angular/core';
import {provideIcons} from '@ng-icons/core';
import {
  matCarRentalOutline,
  matDoNotDisturbOnOutline,
  matMonetizationOnOutline,
  matSyncLockOutline
} from '@ng-icons/material-icons/outline';
import {TabsModule} from 'primeng/tabs';

@Component({
  selector: 'app-parking-challanges',
  templateUrl: './parking-challanges.component.html',
  imports: [TabsModule],
  styleUrl: './parking-challanges.component.scss',
  providers: [
    provideIcons({
      matDoNotDisturbOnOutline,
      matCarRentalOutline,
      matMonetizationOnOutline,
      matSyncLockOutline
    })
  ]
})

export class ParkingChallangesComponent {

  protected activeTab: string = "0";

  tabs = [
    {
      value: '0',
      label: $localize`:@@autopark.tabs.availability.label:Dostępność`,
      title: $localize`:@@autopark.tabs.availability.title:Dostępność miejsc`,
      content: $localize`:@@autopark.tabs.availability.content:Udostępniamy 1500 miejsc w Warszawie z możliwością rezerwacji bloków dopasowanych do wolumenu i sezonowości. Zapewniamy stabilną dostępność bez konieczności rozpraszania floty po wielu lokalizacjach.`,
      image: 'assets/parking/images/parking-lots-occupancy.webp'
    },
    {
      value: '1',
      label: $localize`:@@autopark.tabs.security.label:Bezpieczeństwo`,
      title: $localize`:@@autopark.tabs.security.title:Bezpieczna logistyka`,
      content: $localize`:@@autopark.tabs.security.content:Proces przyjęć i wydań jest uporządkowany i realizowany w uzgodnionych terminach, co ogranicza ryzyko uszkodzeń, pomyłek i przestojów. Pojazdy są lokowane w wyznaczonych strefach ułatwiających szybki odbiór.`,
      image: 'assets/parking/images/car-delivery.webp'
    },
    {
      value: '2',
      label: $localize`:@@autopark.tabs.financing.label:Finansowanie`,
      title: $localize`:@@autopark.tabs.financing.title:Transparentność kosztów`,
      content: $localize`:@@autopark.tabs.financing.content:Model wynajmu miejsc eliminuje nakłady inwestycyjne oraz koszty stałe utrzymania placu. Rozliczenie jest przewidywalne i skalowalne wraz ze zmianą wielkości floty.`,
      image: 'assets/parking/images/budget-analysis.webp'
    },
    {
      value: '3',
      label: $localize`:@@autopark.tabs.solutions.label:Rozwiązania`,
      title: $localize`:@@autopark.tabs.solutions.title:Indywidualna oferta`,
      content: $localize`:@@autopark.tabs.solutions.content:Zapewniamy skalowalne pule miejsc i zasady obsługi dopasowane do wymagań kampanii, premier i dostaw. Ustalamy jasne reguły przechowywania i wydań, aby przyspieszyć wprowadzenie pojazdów na rynek.`,
      image: 'assets/parking/images/parking-lot-consulting.webp'
    }
  ] as const;
}
